const GUEST_SHORTLIST_COMPANY_IDS_KEY = "gt_guest_shortlist_company_ids";

function normalizeCompanyIds(ids: unknown): string[] {
  if (!Array.isArray(ids)) return [];
  const unique = new Set<string>();
  ids.forEach((id) => {
    if (typeof id !== "string") return;
    const trimmed = id.trim();
    if (!trimmed) return;
    unique.add(trimmed);
  });
  return Array.from(unique);
}

export function readGuestShortlistCompanyIds(): string[] {
  const raw = localStorage.getItem(GUEST_SHORTLIST_COMPANY_IDS_KEY);
  if (!raw) return [];
  try {
    return normalizeCompanyIds(JSON.parse(raw));
  } catch {
    return [];
  }
}

export function saveGuestShortlistCompanyIds(companyIds: string[]) {
  const normalized = normalizeCompanyIds(companyIds);
  localStorage.setItem(GUEST_SHORTLIST_COMPANY_IDS_KEY, JSON.stringify(normalized));
}

export function addGuestShortlistCompanyId(companyId: string) {
  const current = readGuestShortlistCompanyIds();
  if (current.includes(companyId)) return current;
  const next = [...current, companyId];
  saveGuestShortlistCompanyIds(next);
  return next;
}

export function removeGuestShortlistCompanyIds(companyIdsToRemove: string[]) {
  if (companyIdsToRemove.length === 0) return readGuestShortlistCompanyIds();
  const removeSet = new Set(companyIdsToRemove.map((id) => id.trim()).filter(Boolean));
  const next = readGuestShortlistCompanyIds().filter((id) => !removeSet.has(id));
  saveGuestShortlistCompanyIds(next);
  return next;
}

export function removeGuestShortlistCompanyId(companyId: string) {
  return removeGuestShortlistCompanyIds([companyId]);
}
